import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  "data-name": "Ebene 1",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13 .2C5.93.2.2 5.93.2 13S5.93 25.8 13 25.8 25.8 20.06 25.8 13 20.06.2 13 .2M8.8 20.66H5.5V9.76h3.3zM7.11 8.19c-1.07 0-1.94-.9-1.94-1.99 0-1.1.88-1.98 1.96-1.97 1.06 0 1.98.93 1.98 1.98s-.94 1.98-1.99 1.98Zm14.48 12.47H18.2v-3.79c0-.92-.02-1.84-.07-2.76-.06-.96-.54-1.6-1.55-1.67-.99-.06-1.76.33-1.99 1.34-.14.66-.16 1.37-.17 2.05-.02 1.57 0 3.14 0 4.79h-3.34V9.75h3.1c.03.39.06.76.08.88 1.04-.39 2.08-1.05 3.17-1.15 2.46-.23 3.86 1.1 4.13 3.59.06.54.05 1.08.06 1.62v5.98Z" }, null, -1)
  ])))
}
export default { render: render }